module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ipadfp"
  }, [_c('img', {
    staticClass: "imagefp",
    attrs: {
      "alt": "Cover: The Shimmering State, by Meredith Westgate",
      "aria-describedby": "cover-alt",
      "role": "doc-cover",
      "src": "e9781982156732/images/9781982156732.jpg"
    }
  })]), _vm._v(" "), _c('aside', {
    attrs: {
      "hidden": "hidden",
      "id": "cover-alt"
    }
  }, [_c('p', [_vm._v("“An impressive, unsettling, and surprisingly romantic debut.” —Helen Schulman, author of "), _c('i', [_vm._v("Come with Me")])]), _vm._v(" "), _c('p', [_vm._v("The Shimmering State")]), _vm._v(" "), _c('p', [_vm._v("A Novel")]), _vm._v(" "), _c('p', [_vm._v("Meredith Westgate")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-324ae84d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781982156732/xhtml/cover.vue
// module id = 54
// module chunks = 0